import React from 'react';
import injectSheet from 'react-jss';
import { graphql } from 'react-apollo';
import queryString from 'query-string';

import { gqlResendConfirmSignupEmail } from 'shared/gql/auth';
import { compose } from 'shared/helpers';

import { mixClasses as cx } from 'helpers/styleHelper';
import { HorizontalRule, Link, TwoColumnInfoTable } from 'components/elems';
import { InitialLoading, GenericError } from 'pages';



let ResendRequestSuccessFeedback = ({
  classes: cn,
  metadata = {},
}) => {
  const {
    email,
    email_confirm_token: token,
  } = metadata;
  // TODO: Derive the root path from somewhere central.
  const resendLinkTo = `/a/resend/confirm-signup-email?token=${token}`;
  const resendLink = (
    <Link type="accented" to={resendLinkTo} target="_blank">
      resending
    </Link>
  );

  return (
    <div className="moa-ff-sans black-70 mt5">
      <div className={cx(cn.heading, 'f1 mb4 fw7')}>
        Sent!
      </div>
      <div className={cx(cn.bodyCon, 'mt5 lh-copy')}>
        <div className="f4 fw6">
          Please check your inbox at:
          <span className="ph3">
            {email}
          </span>
        </div>

        <div className="center mt5">
          <HorizontalRule align="left" thickness="2px" width="4rem" />
          <TwoColumnInfoTable
            className={cx(cn.table, 'mv2')}
            rows={[
              [
                <span>Still No Email?</span>,
                <span>
                  Please be sure to check your spam folder.
                  You can also try {resendLink} the confirmation email again.
                </span>
              ],
            ]}
          />
        </div>
      </div>
    </div>
  );
};
ResendRequestSuccessFeedback = injectSheet({
  heading: {
    opacity: 0,
    animation: `opacityFadeInFull 500ms ease-in-out 1 forwards,
                translatePositionUp 350ms ease-in-out forwards`
  },
  bodyCon: {
    opacity: 0,
    animation: `opacityFadeInFull 500ms ease-in-out 400ms 1 forwards,
                translatePositionUp 350ms ease-in-out 400ms 1 forwards`
  },
  table: {
    borderSpacing: '0 2.5rem',
    marginTop: '-1.5rem',
  },
})(ResendRequestSuccessFeedback);



const ResendConfirmSignupEmail = ({data, ...rest}) => {
  if (data.loading) {
    return (
      <InitialLoading
        showNavbarOnUnmount={true}
        showFooterOnUnmount={false}
      />
    );
  }

  const [
    {name: {value: fieldName}},
  ] = gqlResendConfirmSignupEmail.definitions;

  const { errors } = data[fieldName];
  if (errors.length) {
    return (
      <GenericError
        headline="Unable to resend a signup confirmation email."
        subheading="This link is either invalid or has been used already."
      >
        <div className="mt5">
          <HorizontalRule align="left" thickness="2px" width="4rem" />
          <TwoColumnInfoTable
            className="mv3"
            rows={[
              [
                <span>What Now?</span>,
                <span>
                  Try <Link type="accented" to="/login">logging in</Link> to
                  your account, you might have already confirmed
                  your email. If not, we will send you a new one then as needed.
                </span>
              ],
            ]}
          />
        </div>
      </GenericError>
    );
  }

  const metadata = JSON.parse(data[fieldName].metadata);
  return (
    <div className="min-vh-100 pt5 ph5 mw7 center">
      <div className="mt4">
        <ResendRequestSuccessFeedback metadata={metadata} />
      </div>
    </div>
  );
};


export default compose(
  graphql(gqlResendConfirmSignupEmail, {
    options: ({location}) => {
      const { token } = queryString.parse(location.search);
      const variables = { token };
      return { variables };
    },
  }),
)(ResendConfirmSignupEmail);



// WEBPACK FOOTER //
// ./src/pages/a/resend/ResendConfirmSignupEmail.js